import * as React from "react";
import {Route} from "react-router-dom";
import LazyLoadingWrapper from "../../components/LazyLoadingWrapper/LazyLoadingWrapper";
import LayersListWrapper from "../../containers/map/tools/LayersList/LayersListWrapper";
import LayersTimeSelectors from "../../components/map/LayersTimeSelectors";


const Layers = React.lazy(() => import('./LayersModePage'));
const KeplerLayers = React.lazy(() => import('../KeplerLayers/KeplerLayersModePage'));

export const useLayersRoutes = () => {
    return (
        <>
            <Route element={<LazyLoadingWrapper element={<Layers/>}/>}>
                <Route index element={
                    <LayersListWrapper>
                        <LayersTimeSelectors/>
                    </LayersListWrapper>
                }/>
            </Route>
            <Route path="klayers" element={<LazyLoadingWrapper element={<KeplerLayers/>}/>}/>
        </>
    );
}